import type { BtlApplication } from '@api/btlApplicationForm/types';
import { hasInsufficientApplicantAddressHistory } from './addressHistory';
import type { MissingCaseFields } from '@pages/BtlApplicationFormPage/types';

export function hasAnyMissingFields(missingFields?: MissingCaseFields | null): boolean {
  if (!missingFields) {
    return false;
  }

  return Object.values(missingFields).some(sectionData => {
    if (!Array.isArray(sectionData)) {
      return false;
    }

    return sectionData.some(item => (item.missingFields?.length ?? 0) > 0);
  });
}

export function shouldBlockSubmissionForMissingFields(
  application?: BtlApplication | null,
  missingFields?: MissingCaseFields | null,
  isComplete?: boolean,
): boolean {
  if (typeof isComplete === 'boolean') {
    return !isComplete || hasInsufficientApplicantAddressHistory(application);
  }

  return hasAnyMissingFields(missingFields) || hasInsufficientApplicantAddressHistory(application);
}
